import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=c0aa03e4&"
import script from "./VerifyCode.vue?vue&type=script&lang=js&"
export * from "./VerifyCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports